// @ai-generated 2026-08-27T11:34:55+00:00 by kai.cissarek@synqony.com using Claude Opus 5
import { FrameListContainerStock } from '@Modules/Orders';
import { Navigate, type RouteObject } from 'react-router';

/**
 * A list and nothing else: a standing time is not edited, so the module has no detail route and
 * cannot use {@link setupModuleRouting}, which insists on an edit frame.
 */
export function setupContainerStockRouting(): RouteObject {
    return {
        path: 'container_stock',
        children: [
            { path: '', element: <Navigate to="list" replace /> },
            { path: 'list', element: <FrameListContainerStock /> },
        ],
    };
}
